import {
  DEV_TG_WRAPPER_LINK,
  PROD_TG_BOT_LINK,
  PROD_TG_WRAPPER_LINK,
} from '@/shared/constants';

import { base64Utils } from '../base64-utils';
import { getIsDev } from '../environment/get-is-dev';

export const makeTwaReturnLink = (
  gameKey: string | undefined
): `${string}://${string}` => {
  if (!gameKey) {
    return PROD_TG_BOT_LINK;
  }

  const encodedStartapp = base64Utils.encode({
    game: {
      key: gameKey,
    },
  });

  const isDev = getIsDev();

  const wrapperLink = isDev ? DEV_TG_WRAPPER_LINK : PROD_TG_WRAPPER_LINK;

  const returnLink = `${wrapperLink}?startapp=${encodedStartapp}`;

  return returnLink as `${string}://${string}`;
};
